﻿'use strict';

angular.module('ntmApp')
  .controller('RoomRackCensusController', ['$scope', 'TALocationService', 'TodaysAssignments',
      function ($scope, TALocationService, TodaysAssignments) {

      $scope.todaysAssignments = new TodaysAssignments();

      $scope.save = function () {
          $scope.todaysAssignments.roomRackCensus.SaveRackCensus();
      };

      $scope.cancel = function () {
          $scope.todaysAssignments.roomRackCensus.ResetRackCensus();
      };

      $scope.back = function () {

          if ($scope.todaysAssignments.roomRackCensus.rackCensusData.facilityCode && $scope.todaysAssignments.roomRackCensus.rackCensusData.roomNumber) {
              TALocationService.GoToTheRoomGroups($scope.todaysAssignments.roomRackCensus.rackCensusData.facilityCode, $scope.todaysAssignments.roomRackCensus.rackCensusData.roomNumber);
          } else {
              TALocationService.GoToTheHomePage();
          }
      };

      $scope.selectRackTab = function (rackTabNumber) {
          $scope.selectedRackTabNumber = $scope.todaysAssignments.roomRackCensus.selectRackTab(rackTabNumber);
      };

      function init() {
          $scope.todaysAssignments.roomRackCensus.LoadRoomRackCensus();
      }

      init();

  }]);